/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
//import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginAppComponent } from './login/components/login-app.component';
import { LogoutComponent } from './logout/components/logout.component';
import { NgForm, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AuthGuard} from './login/components/AuthGuard';
import {AuthInterceptor} from './login/components/AuthInterceptor';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { environment } from '../../environments/environment';
import {DirectionService} from '../../src/app/pages/car-map-online/services/direction.service';


//import { AngularFireMessagingModule } from '@angular/fire/messaging';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbCardModule,
  NbAlertModule,
  NbCheckboxModule,
  NbInputModule,
  NbButtonModule,
  NbCalendarMonthCellComponent
} from '@nebular/theme';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { AsyncPipe } from '../../node_modules/@angular/common';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { BrowserModule } from '@angular/platform-browser';
import { NbSpinnerModule } from '@nebular/theme';
import { MatDialogModule } from '@angular/material';
import { DataSendService } from './pages/car-map-online/services/datasend.service';
//import { HistoryTripNotAllow } from './map/historytripnotallow.component';
//import { HistoryTripNotAllow } from '../app/logout/components/historytripnotallow.component';

//import { ModalCarComponent } from './pages/car-map-online/components/modalcar.component';
// import { NbMomentDateModule } from '@nebular/moment';
// import { NbDateFnsDateModule } from '@nebular/date-fns';
//import { NbTimepickerModule } from '@nebular/theme';
@NgModule({
 
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: environment.googleKey,
    }),
    Ng2SmartTableModule,
    NbCardModule,
    NbAlertModule,
    NbCheckboxModule,
    NbInputModule,
    NbButtonModule,
    CoreModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    NbSpinnerModule,
    MatDialogModule,
    LeafletModule
    // NbMomentDateModule,
    // NbDateFnsDateModule 
    // RouterModule.forRoot([
    //   { path: '', component: HomeComponent, pathMatch: 'full' },
    //   { path: 'counter', component: CounterComponent },
    //   { path: 'fetch-data', component: FetchDataComponent },
    // ]),
   
  ],
  declarations: [AppComponent, LoginAppComponent, LogoutComponent],
  providers: [    
   AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    DirectionService,
    DataSendService,
    //MessagingService,
    AsyncPipe
  
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  // constructor(){
  //   Object.defineProperty(NbCalendarMonthCellComponent.prototype, 'selected', {
  //     get() {
  //       return this.dateService.isSameMonthSafe(
  //         this.date,
  //         this.selectedValue ? this.selectedValue.end : new Date()
  //       );
  //     },
  //     enumerable: true,
  //     configurable: true
  //   });
  // }
}
